import { Link } from 'react-router-dom';
import { LegalLayout } from '../../components/LegalLayout';

export function ConfidentialitePage() {
  return (
    <LegalLayout
      title="Politique de confidentialité"
      lead="Dernière mise à jour : juillet 2026 · Dezoom (dezoom.eu)"
    >
      <h2>1. Responsable du traitement</h2>
      <p>
        Florian Augeard — PrograGames<br />
        49000 Angers, France<br />
        Contact :{' '}
        <a href="https://progragames.com/contact.html" target="_blank" rel="noopener noreferrer">
          progragames.com/contact
        </a>
      </p>

      <h2>2. Données collectées</h2>
      <p>Selon ton utilisation, nous pouvons traiter :</p>
      <ul>
        <li><strong>Compte</strong> : email, pseudo, avatar (Google si utilisé), statut invité/enregistré ;</li>
        <li><strong>Gameplay</strong> : scores, série de victoires, parties jouées, Elo arène, progression ligues ;</li>
        <li><strong>Social</strong> : liste d'amis, demandes d'amitié, membres de ligues ;</li>
        <li><strong>Achats</strong> : identifiant Stripe, session de paiement, horodatage (pas de numéro de carte côté PrograGames) ;</li>
        <li><strong>Technique</strong> : adresse IP (sécurité, rate limiting), logs serveur.</li>
      </ul>

      <h2>3. Finalités et bases légales</h2>
      <ul>
        <li>Exécution du contrat (CGU) : compte, jeu, classements, achats ;</li>
        <li>Intérêt légitime : sécurité, anti-triche, amélioration du service ;</li>
        <li>Obligation légale : conservation de preuves comptables liées aux ventes.</li>
      </ul>

      <h2>4. Sous-traitants</h2>
      <ul>
        <li>
          <strong>Stripe</strong> — paiements (
          <a href="https://stripe.com/fr/privacy" target="_blank" rel="noopener noreferrer">politique Stripe</a>
          ) ;
        </li>
        <li><strong>Scaleway</strong> — hébergement en France/UE ;</li>
        <li><strong>Mailjet</strong> — envoi des liens magiques de connexion (si activé).</li>
      </ul>

      <h2>5. Durées de conservation</h2>
      <ul>
        <li>Compte actif : durée de vie du compte puis suppression ou anonymisation sur demande ;</li>
        <li>Données d'achat : durée légale comptable (10 ans) ;</li>
        <li>Logs techniques : quelques semaines à quelques mois.</li>
      </ul>

      <h2>6. Cookies et stockage local</h2>
      <p>
        Dezoom utilise le <strong>localStorage</strong> pour le token de session et préférences.
        Pas de publicité tierce ni de cookies analytics en l'état actuel.
      </p>

      <h2>7. Tes droits (RGPD)</h2>
      <p>
        Tu disposes des droits d'accès, rectification, effacement, limitation, opposition et portabilité.
        Contact :{' '}
        <a href="https://progragames.com/contact.html" target="_blank" rel="noopener noreferrer">
          PrograGames
        </a>
        . Réclamation CNIL :{' '}
        <a href="https://www.cnil.fr/" target="_blank" rel="noopener noreferrer">cnil.fr</a>.
      </p>

      <h2>8. Sécurité</h2>
      <p>
        Mesures techniques raisonnables (HTTPS, tokens hashés, rate limiting).
      </p>

      <h2>9. Mineurs</h2>
      <p>
        Le jeu est destiné aux 16 ans et plus (voir <Link to="/cgu">CGU</Link>).
      </p>
    </LegalLayout>
  );
}
